import { render, staticRenderFns } from "./wxRegionList.vue?vue&type=template&id=5df51ebc&scoped=true"
import script from "./wxRegionList.vue?vue&type=script&lang=js"
export * from "./wxRegionList.vue?vue&type=script&lang=js"
import style0 from "./wxRegionList.vue?vue&type=style&index=0&id=5df51ebc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df51ebc",
  null
  
)

export default component.exports